import React, { PropTypes } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import ReactTimeout from "react-timeout";

import { BSModal } from "../../../../common";

class CancelInvoiceButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = { showModal: false };

    this.close = this.close.bind(this);
    this.confirmOperation = this.confirmOperation.bind(this);
    this.confirmed = this.confirmed.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  confirmOperation() {
    this.setState({ showModal: true });
  }

  confirmed() {
    this.setState({ showModal: false });
    this.props.setTimeout(this.props.cancelFunction, 100);
  }

  render() {
    return (
      <span className="dataTable-action-button">
        <span
          className="dataTable-action-button action-icon icon-bin"
          onClick={this.confirmOperation}
        >
          {this.props.label}
        </span>
        <BSModal
          show={this.state.showModal}
          title={
            <FormattedMessage id="invoices.cancelButton.title">
              {(f) => <span className="icon warning">{f}</span>}
            </FormattedMessage>
          }
          actions={[
            {
              id: 1,
              text: <FormattedMessage id="common.confirm" />,
              action: this.confirmed,
            },
          ]}
          onClose={this.close}
        >
          <div>
            {this.props.isLatestInvoice ? (
              <FormattedMessage
                id="invoices.cancelButton.standardMessage"
                values={{ invoiceName: this.props.invoiceName }}
              />
            ) : (
              <FormattedHTMLMessage
                id="invoices.cancelButton.warningMessage"
                values={{ invoiceName: this.props.invoiceName }}
              />
            )}
          </div>
        </BSModal>
      </span>
    );
  }
}

CancelInvoiceButton.propTypes = {
  cancelFunction: PropTypes.func.isRequired,
  invoiceName: PropTypes.string,
  isLatestInvoice: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setTimeout: PropTypes.func,
};

export default ReactTimeout(CancelInvoiceButton);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/CancelInvoiceButton.js